var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 11L38 11L38 37L12 37L12 11Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grupo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z",
    id: "Ellipse-4",
    fill: "#0D9C7A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11L38 11L38 37L12 37L12 11Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(32.236084 24.879517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.01074 0L0 0C0.204954 0.561134 0.316927 1.1667 0.316927 1.79786L0.316927 9.39729C0.316927 9.66044 0.271122 9.91303 0.187789 10.1479L3.51199 10.1479C4.75374 10.1479 5.76394 9.1377 5.76394 7.89599L5.76394 3.7532C5.76399 1.68371 4.08028 0 2.01074 0L2.01074 0Z",
    id: "Shape",
    fill: "#BDFCED",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12 24.879639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.44706 1.79786C5.44706 1.16665 5.55903 0.561133 5.76399 0L3.75325 0C1.68371 0 2.47955e-07 1.68371 2.47955e-07 3.75325L2.47955e-07 7.89604C2.47955e-07 9.13775 1.01019 10.148 2.25195 10.148L5.5762 10.148C5.49287 9.91298 5.44706 9.66044 5.44706 9.39729L5.44706 1.79786L5.44706 1.79786Z",
    id: "Shape",
    fill: "#BDFCED",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(18.948242 22.924194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.35008 0L3.75325 0C1.68371 0 0 1.68371 0 3.75325L0 11.3527C0 11.7672 0.336071 12.1033 0.75065 12.1033L11.3527 12.1033C11.7673 12.1033 12.1033 11.7673 12.1033 11.3527L12.1033 3.75325C12.1033 1.68371 10.4196 0 8.35008 0L8.35008 0Z",
    id: "Shape",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.486328 12.97229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51375 0C2.02486 0 0 2.02486 0 4.5138C0 6.20203 0.931786 7.67646 2.30786 8.45057C2.96055 8.81772 3.71303 9.02755 4.51375 9.02755C5.31447 9.02755 6.06695 8.81772 6.71964 8.45057C8.09577 7.67646 9.0275 6.20198 9.0275 4.5138C9.0275 2.02491 7.00265 0 4.51375 0L4.51375 0Z",
    id: "Shape",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.698242 17.179565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37569 0C1.5143 0 0 1.5143 0 3.37569C0 5.23708 1.5143 6.75138 3.37569 6.75138C3.84786 6.75138 4.29747 6.65358 4.70591 6.47777C5.41207 6.17374 5.99433 5.63556 6.35463 4.96144C6.60752 4.48831 6.75138 3.94855 6.75138 3.37569C6.75138 1.51435 5.23708 0 3.37569 0L3.37569 0Z",
    id: "Shape",
    fill: "#BDFCED",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(29.550293 17.179565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37569 0C1.5143 0 0 1.5143 0 3.37569C0 3.9486 0.143864 4.48836 0.396754 4.96144C0.757047 5.63561 1.33931 6.17379 2.04547 6.47777C2.45391 6.65358 2.90353 6.75138 3.37569 6.75138C5.23708 6.75138 6.75138 5.23708 6.75138 3.37569C6.75138 1.5143 5.23708 0 3.37569 0L3.37569 0Z",
    id: "Shape",
    fill: "#BDFCED",
    fillRule: "evenodd",
    stroke: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/usersIcon.d3232f4744b5c1da9f39d37964c321be.svg";
export { ForwardRef as ReactComponent };